import React from 'react';
import { applyMiddleware, compose, createStore } from 'redux';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import createReduxWaitForMiddleware from 'redux-wait-for-action';
import { persistStore, persistReducer } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import storage from 'redux-persist/lib/storage';
import rootReducer from './root-reducer';
import rootSaga from './root-saga';
import whitelist from './whitelist';

const persistConfig = { key: 'root', storage, whitelist };
const persistedReducer = persistReducer(persistConfig, rootReducer);

const sagaMiddleware = createSagaMiddleware();
const waitForMiddleware = createReduxWaitForMiddleware();

/**
 * Redux DevTools exposes the entire store - including the identity token - to
 * any browser extension or injected script, so it is development-only.
 */
const composeEnhancers = (process.env.NODE_ENV !== 'production'
  && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const enhancer = composeEnhancers(
  applyMiddleware(sagaMiddleware, waitForMiddleware),
);

/**
 * Redux Store Instance
 */
export const store = createStore(persistedReducer, enhancer);

/**
 * Redux Persist Instance
 */
export const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

type Props = {
  children: React.ReactNode,
};

/**
 * Redux Store Component
 * @param {Props} props
 */
export default ({ children }: Props) => (
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      {children}
    </PersistGate>
  </Provider>
);
